import React from 'react';
import styled, { keyframes } from 'styled-components';
import Text from 'components/_UI/Text';
import currency from 'helpers/currency';
import colors from 'theme/colors';
import breakpoints from 'theme/breakpoints';
import indexPriority from 'theme/z-index';

const slideUp = keyframes`
    from {
        transform: translateY(100%);
    }
    to {
        transform: translateY(0);
    }
`;

const slideUpDesktop = keyframes`
    from {
        transform: translate(-50%, 100%);
    }
    to {
        transform: translate(-50%, 0);
    }
`;

const Wrapper = styled.div`
    position: fixed;
    bottom: 60px;
    left: 0;
    right: 0;
    z-index: ${indexPriority.medium};
    background: ${colors.occasionalPurple};
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 12px 16px;
    box-shadow: 0 -2px 12px rgba(0, 0, 0, 0.15);
    animation: ${slideUp} 0.3s ease-out;

    @media (min-width: ${breakpoints.lg}) {
        display: none;
    }
`;

const CheckoutButton = styled.button`
    background: ${colors.neutralLight};
    color: ${colors.occasionalPurple};
    border: none;
    border-radius: 8px;
    padding: 8px 20px;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 8px;
    opacity: ${({ disabled }) => (disabled ? 0.5 : 1)};
    pointer-events: ${({ disabled }) => (disabled ? 'none' : 'auto')};
`;

const LeftSection = styled.div`
    display: flex;
    align-items: center;
`;

const RightSection = styled.div`
    display: flex;
    align-items: center;
    gap: 12px;
`;

const StickyCartBar = ({ itemCount, totalPrice, onCheckout, disabled }) => {
    if (itemCount === 0) return null;

    const itemLabel = itemCount === 1 ? '1 item' : `${itemCount} itens`;

    return (
        <Wrapper>
            <LeftSection>
                <Text color={colors.neutralLight} size="14" weight="600">
                    {itemLabel}
                </Text>
            </LeftSection>
            <RightSection>
                <Text color={colors.neutralLight} size="16" weight="700">
                    {currency.format(totalPrice)}
                </Text>
                <CheckoutButton onClick={onCheckout} disabled={disabled}>
                    Pedir
                </CheckoutButton>
            </RightSection>
        </Wrapper>
    );
};

export default StickyCartBar;
